export default __webpack_public_path__ + "static/media/view.b7d4ee71.svg";